export enum LinkAgentProfileModelModes {
  VIEW = "view",
  CREATE = "create",
  EDIT = "edit",
}
